import React, { ReactNode } from 'react';
import { IonText } from '@ionic/react';
import { Card } from '../../components/Card';
import { CardHeading } from '../components/CardHeading';
import { ICareEvent } from '../model/ICheckin';
import { CheckinDetailsConfig } from '../model/CheckinDetailsConfig';
import { CheckinIcon } from '../components/CheckinIcon';
import { IPeriodData } from '../model/IPeriodData';
import { PctChangeIndicator } from './PctChangeIndicator';

const Row: React.FC<{'data-type'?: string, children: ReactNode}> = ({ 'data-type': dataType, children }) => (
    <div data-type={dataType} style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
        {children}
    </div>
);

export const CareTimeTotalsCard: React.FC<{selectedPeriod: IPeriodData, priorPeriod: IPeriodData}> = ({ selectedPeriod, priorPeriod }) => {
    const config = CheckinDetailsConfig['CARE_EVENTS'];

    let total = 0;
    const eventTotals: {[key in ICareEvent]?: number} = {};

    for (const c of selectedPeriod.care) {
        const { totalCareHours, careEvents, careEventHours } = c;
        total += totalCareHours || 0;
        for (const e of careEvents || []) {
            const hours = careEventHours ? careEventHours[e] || 0 : 0;
            eventTotals[e] = (eventTotals[e] || 0) + hours;
        }
    }

    let priorTotal = 0;

    for (const c of priorPeriod.care) {
        priorTotal += c.totalCareHours || 0;
    }

    const events = (Object.keys(eventTotals) as ICareEvent[])
        .filter(e => eventTotals[e]! > 0)
        .sort((e1, e2) => eventTotals[e2]! - eventTotals[e1]!);

    return (
        <Card dataProps={{dataId: 'care-times-card'}}padded>
            <CardHeading>Care Time</CardHeading>

            <Row>
                <IonText>Total hours</IonText>
                <IonText data-id="total-hours"><b>{total}h</b></IonText>
            </Row>

            <Row>
                <div />
                <div style={{marginBottom: 10, height: 15}}>
                    <PctChangeIndicator oldValue={priorTotal} newValue={total} />
                </div>
            </Row>

            {events.map(event => {
                const { Icon, activeColor } = config.icons.find(i => i.label === event)!;
                return (
                    <Row key={event} data-type="care-row">

                        <div style={{display: 'flex', alignItems: 'center', gap: 10}}>

                            <CheckinIcon
                                active
                                Icon={Icon}
                                iconSize="small"
                                activeColor={activeColor}
                            />

                            <IonText data-type="care-event">{event}</IonText>

                        </div>

                        <IonText data-type="care-hours">{eventTotals[event]}h</IonText>

                    </Row>
                );
            })}
        </Card>
    );
};
